
import { Row, Column } from '~/components/grid'
import { UiTitle, UiButton, UiLink } from '~/components/atoms'

export default {
  name: 'BusinessBanner',
  components: {
    Row,
    Column,
    UiTitle,
    UiButton,
    UiLink,
  },
  props: {
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    isMobile() {
      return this.$mq === 'sm'
    },
    getImageUrl(): string {
      const size = this.isMobile ? 'MO' : 'DT'
      // eslint-disable-next-line global-require
      return require(`@/assets/images/business/business_hero_${size}.png`)
    },
  },
}
